import { gql } from '@apollo/client';

export const DUPLICATE_INDICATOR = gql`
  mutation duplicateIndicator($id: ID!) {
    duplicateIndicator(id: $id) {
      id
    }
  }
`;
